<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="content">
        <h4>My deployments</h4>
        <c-button class="right-align" :onClick="deployNewApp" variant="primary">Deploy new app</c-button>
        <br>
        <br>
        <b-table :fields="deploymentsTable" :items="deployments" responsive="sm">
          <template #cell(name)="data">
            <router-link :to="{ name: 'Deployment', params: { id: data.item.id }}">
              <b>{{ data.item.name }}</b>
            </router-link>
          </template>
          <template #cell(repo)="data">
            {{ data.item.repo }}
          </template>
          <template #cell(language)="data">
            {{ data.item.language }}
          </template>
          <template #cell(domain)="data">
            {{ data.item.domain }}
          </template>
          <template #cell(regions)="data">
            {{ data.item.deploymentLocations.map(deploymentLocation => deploymentLocation.region).join(', ') }}
          </template>
          <template #cell(status)="data">
            <span v-if="data.item.status === 'running'" class="success">{{ data.item.status }}</span>
            <span v-else-if="data.item.status === 'stopped'" class="failure">{{ data.item.status }}</span>
          </template>
          <template #cell(createdAt)="data">
            {{ data.item.createdAt | date }}
          </template>
        </b-table>
        <div class="center-align">
          <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'listDeployments', 'deploymentsPagination')"/>
            Page: {{ deploymentsPagination.page }} / {{ deploymentsPagination.totalPages }}
          <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'listDeployments', 'deploymentsPagination')"/>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import { PaginationModule } from '../utils.js'

  export default {
    name: 'Deployments',
    components: { CButton },
    props: {

    },
    data() {
      return {
        failureMessage: '',
        deployments: [],
        deploymentsPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null
        },
        deploymentsTable: [
          {
            key: 'name'
          },
          {
            key: 'repo'
          },
          {
            key: 'language'
          },
          {
            key: 'domain'
          },
          {
            key: 'regions'
          },
          {
            key: 'status'
          },
          {
            key: 'createdAt',
            label: 'Created on'
          }
        ],
      }
    },
    async created() {
      await this.listDeployments()
    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
    },
    methods: {
      deployNewApp() {
        this.$router.push({ name: "Deploy" })
      },
      async listDeployments() {
        this.failureMessage = ''
        this.deployments = []

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/listDeployments.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            page: this.deploymentsPagination.page,
            itemsPerPage: this.deploymentsPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listDeployments) {
          this.deployments.push(...result.data.listDeployments.deployments)
          this.deploymentsPagination.count = result.data.listDeployments.pagination.count
          this.deploymentsPagination.totalPages = result.data.listDeployments.pagination.totalPages
        }
      },
      pagination(type, funcToExecute, obj) {
        const paginationModule = PaginationModule();
        const newPage = paginationModule.changePage(type, this[obj].page, this[obj].totalPages);
        if (newPage) {
          this[obj].page = newPage;
          this[funcToExecute](this[obj].payload);
        }
      },
    }
  }
</script>

<style scoped>

</style>
